import React,{useEffect,useState,useContext} from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import axios from 'axios';
import { AppContext } from '../../Context';
import Popover from 'react-bootstrap/Popover';
import Button from 'react-bootstrap/Button';
import logo from '../../assets/marutilogo.png';
import userIcon from '../../assets/icon.jpg'
import useAccess from '../../Page/LoginPage/useAccess';
import './MainHeader.css';
import { ENV_URL, LAST_UPDATED } from '../../Essentials/variables';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import DropdownToggle from 'react-bootstrap/esm/DropdownToggle';
import DropdownMenu from 'react-bootstrap/esm/DropdownMenu';
import DropdownItem from 'react-bootstrap/esm/DropdownItem';
import { getADFSLogoutUrl } from '../../store/apis/authApi';



export default function MainHeader(props) {
  const [userInfo,setUserInfo] = useState(JSON.parse(localStorage.getItem('userInfo')));
  // const {tokenValid,setTokenValid} = useContext(AppContext);
  // const { mapData, setMapData, stateData, setStateData, loader, setLoader } = useContext(AppContext);
  const [popover,setPopover] = useState();
  const [lastupdateddate,setlastupdatedDate]=useState('')
  const [lastupdatedtime,setlastupdatedTime]=useState('')
  const {removeAccess} = useAccess();
  const refresh = () => window.location.reload(true);

  const logoutFn = async () => {
    removeAccess();
    await getADFSLogoutUrl();
      props.nav('/');
  }
  const loginInfo = ({placement, scheduleUpdate, arrowProps, outOfBoundaries, show, ...props}) => (
    <div
       {...props}
       style={{
          // backgroundImage: 'linear-gradient(rgba(7,10,82,0.3), rgba(7,10,82,0.3)), url(loginbg.jpg)',
          backgroundColor: 'rgba(23,28,143,1)',
          padding: '2px 10px',
          color: 'white',
          borderRadius: 3,
          ...props.style,
       }}
    >
         <ul style={{"list-style": "none","marginLeft":"-30px","paddingTop":"5px","display":"flex","flexDirection":"column","justifyContent":"space-evenly","zIndex":"99"}}>
        <li><h6>Hi, {userInfo.Name}</h6></li>
        <li><Button variant="danger" onClick={logoutFn}>Logout</Button></li>
      </ul>
      
    </div>
 );

 const dateInfo = ({placement, scheduleUpdate, arrowProps, outOfBoundaries, show, ...props}) => (
  <div
     {...props}
     style={{
        // backgroundImage: 'linear-gradient(rgba(7,10,82,0.3), rgba(7,10,82,0.3)), url(loginbg.jpg)',
        backgroundColor: 'rgba(23,28,143,1)',
        padding: '2px 10px',
        color: 'white',
        borderRadius: 3,
        ...props.style,
     }}
  >
       <ul style={{"list-style": "none","marginLeft":"-30px","paddingTop":"10px","display":"flex","flexDirection":"column","justifyContent":"space-evenly","zIndex":"99"}}>
      <li><h6>Last Invoice : {lastupdateddate}({lastupdatedtime})</h6></li>
      <li><h6>Last GIS data Refresh : 15-06-2023</h6></li>
      {/* <li><h6>Last Census Refresh : 2022-10-02</h6></li>
      <li><h6>Last Potential Refresh : 2023-01-16</h6></li> */}
    </ul>
    
  </div>
);
const dateInfo2 = ({placement, scheduleUpdate, arrowProps, outOfBoundaries, show, ...props}) => (
  <div
     {...props}
     style={{
        // backgroundImage: 'linear-gradient(rgba(7,10,82,0.3), rgba(7,10,82,0.3)), url(loginbg.jpg)',
        backgroundColor: 'rgba(23,28,143,1)',
        padding: '2px 10px',
        color: 'white',
        borderRadius: 3,
        ...props.style,
     }}
  >
       <ul style={{"list-style": "none","marginLeft":"-30px","paddingTop":"10px","display":"flex","flexDirection":"column","justifyContent":"space-evenly","zIndex":"99"}}>
      <li><p className='data-info-points'>Count of Hospitals and schools has been taken from census.</p></li>
      <li><p className='data-info-points'>Count of Other POIs has been taken from MMI.</p></li>
      {/* <li><h6>Last Census Refresh : 2022-10-02</h6></li>
      <li><h6>Last Potential Refresh : 2023-01-16</h6></li> */}
    </ul>
    
  </div>
);
 useEffect(()=>{
  let Token=localStorage.getItem('token')
   axios({
     method: 'GET',
     headers: {
       "x-access-token": Token,
       'Content-Type': 'application/json',
       'Accept': 'application/json',
       'X-Frame-Options': 'DENY',
       'Content-Security-Policy': "frame-ancestors 'none'",
       'Feature-Policy': "frame-ancestors 'none'"
     },
     withCredentials: true,
     url: LAST_UPDATED
   }).then((res) => {
     console.log(res.data)
    //  console.log(res?.data?.message)
     setlastupdatedDate(res?.data?.Date);
     setlastupdatedTime(res?.data?.Time);
   })
   .catch((err)=>{
    console.log(err);
   })
},[])

const [dateDropdown,setDateDropdown]=useState(false);
const toggleDropdown = () => {
 setDateDropdown(!dateDropdown)
}
  useEffect(()=>{      
      setPopover(<po uI={userInfo}/>);
  },[userInfo]);
  return (
    <header className="header">
      <div className='home'><i onClick={() => { props.nav(`/gis`);}} className="home-icon bi bi-house-fill"></i></div>
      
      <img id="logo" src = {logo} alt="Maruti Logo" onClick={refresh}/>
      <div className='logout-group'>
        {<OverlayTrigger trigger="click" rootClose placement="bottom" overlay={dateInfo2}>
          {/* <div id="user"><i className="bi bi-person user-icon"></i></div> */}
          <div id="user"> <i style={{ color: '#fff' }} className='bi bi-question-square'></i></div>
        </OverlayTrigger>}
        {/* <i class="bi bi-question-square"></i> */}

        {<OverlayTrigger trigger="click" rootClose placement="bottom" overlay={dateInfo}>
          {/* <div id="user"><i className="bi bi-person user-icon"></i></div> */}
          <div id="user"> <i style={{ color: '#fff' }} className='bi bi-info-circle-fill'></i></div>
        </OverlayTrigger>}

        {localStorage.getItem('userInfo') && <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={loginInfo}>
          {/* <div id="user"><i className="bi bi-person user-icon"></i></div> */}
          <div id="user"><img id="userIcon" src={userIcon} /></div>
        </OverlayTrigger>}
          <img className="h-8 pb-2 pl-2" src="powered-by-logo.png" alt="Logo" />
      </div>
      
      
    </header>
  );
}